<template>
  <section class="table-events-referee">
    <div class="table-events-referee__col-info">
      <div class="table-events-referee__col-info__row-referee-info">
        <img :src="'https://golstatsimages.blob.core.windows.net/photo-referee/' + infoEventReferee.referee_id + '.jpg'" />
        <div class="table-events-referee__col-info__row-referee-info__name">
          {{ changeNameReferee(infoEventReferee.referee_name) }}
        </div>
      </div>
      <div class="table-events-referee__col-info__row-category">VAR</div>
      <div class="table-events-referee__col-info__row-category color-gray">Otros:</div>
    </div>
    <div class="table-events-referee__col">
      <div class="table-events-referee__col__row-title">Eventos totales</div>
      <div class="table-events-referee__col__row-cont-sub-title">
        <div class="table-events-referee__col__row-cont-sub-title__empty"></div>
        <div class="table-events-referee__col__row-cont-sub-title__match-title">
          <template v-if="type == 1">Este</template><template v-else>Último</template> partido <br />
          <template v-if="type == 1">&nbsp;{{ changeMatch(matchday) }}</template>
        </div>
        <div class="table-events-referee__col__row-cont-sub-title__prom-title">
          Su promedio<br />
          actual torneo
        </div>
      </div>
      <div class="table-events-referee__col__row-cont-values">
        <div class="table-events-referee__col__row-cont-values__category">VAR</div>
        <div class="table-events-referee__col__row-cont-values__match-val">
          {{ infoEventReferee.events[0].game_total_events }}
        </div>
        <div class="table-events-referee__col__row-cont-values__prom-val">
          {{ infoEventReferee.events[0].season_total_events }}
        </div>
      </div>
      <div class="table-events-referee__col__row-cont-values color-gray">
        <div class="table-events-referee__col__row-cont-values__category ">Otros:</div>
        <div class="table-events-referee__col__row-cont-values__match-val">
          {{ infoEventReferee.events[1].game_total_events }}
        </div>
        <div class="table-events-referee__col__row-cont-values__prom-val">
          {{ infoEventReferee.events[1].season_total_events }}
        </div>
      </div>
    </div>
    <div class="table-events-referee__col">
      <div class="table-events-referee__col__row-title">Tiempo promedio por evento</div>
      <div class="table-events-referee__col__row-cont-sub-title">
        <div class="table-events-referee__col__row-cont-sub-title__empty"></div>
        <div class="table-events-referee__col__row-cont-sub-title__match-title">
          <template v-if="type == 1">Este</template><template v-else>Último</template> partido <br />
          <template v-if="type == 1">&nbsp;{{ changeMatch(matchday) }}</template>
        </div>
        <div class="table-events-referee__col__row-cont-sub-title__prom-title">
          Su promedio<br />
          actual torneo
        </div>
      </div>
      <div class="table-events-referee__col__row-cont-values">
        <div class="table-events-referee__col__row-cont-values__category">VAR</div>
        <div class="table-events-referee__col__row-cont-values__match-val">
          {{ infoEventReferee.events[0].game_average_time_per_event }}
        </div>
        <div class="table-events-referee__col__row-cont-values__prom-val">
          {{ infoEventReferee.events[0].season_average_time_per_event }}
        </div>
      </div>
      <div class="table-events-referee__col__row-cont-values color-gray">
        <div class="table-events-referee__col__row-cont-values__category">Otros:</div>
        <div class="table-events-referee__col__row-cont-values__match-val">
          {{ infoEventReferee.events[1].game_average_time_per_event }}
        </div>
        <div class="table-events-referee__col__row-cont-values__prom-val">
          {{ infoEventReferee.events[1].season_average_time_per_event }}
        </div>
      </div>
    </div>
    <div class="table-events-referee__col">
      <div class="table-events-referee__col__row-title">Tiempo total por tipo de evento</div>
      <div class="table-events-referee__col__row-cont-sub-title">
        <div class="table-events-referee__col__row-cont-sub-title__empty"></div>
        <div class="table-events-referee__col__row-cont-sub-title__match-title">
          <template v-if="type == 1">Este</template><template v-else>Último</template> partido <br />
          <template v-if="type == 1">&nbsp;{{ changeMatch(matchday) }}</template>
        </div>
        <div class="table-events-referee__col__row-cont-sub-title__prom-title">
          Su promedio<br />
          actual torneo
        </div>
      </div>
      <div class="table-events-referee__col__row-cont-values">
        <div class="table-events-referee__col__row-cont-values__category">VAR</div>
        <div class="table-events-referee__col__row-cont-values__match-val">
          {{ infoEventReferee.events[0].game_total_time_per_event }}
        </div>
        <div class="table-events-referee__col__row-cont-values__prom-val">
          {{ infoEventReferee.events[0].season_total_time_per_event }}
        </div>
      </div>
      <div class="table-events-referee__col__row-cont-values color-gray">
        <div class="table-events-referee__col__row-cont-values__category">Otros:</div>
        <div class="table-events-referee__col__row-cont-values__match-val">
          {{ infoEventReferee.events[1].game_total_time_per_event }}
        </div>
        <div class="table-events-referee__col__row-cont-values__prom-val">
          {{ infoEventReferee.events[1].season_total_time_per_event }}
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'TableEventsReferee',
  components: {},
  props: {
    infoEventReferee: {
      type: Object,
      required: true,
    },
    type: {
      type: Number,
      default: 1,
      required: true,
    },
    matchday: {
      type: String,
      default: '',
      required: true,
    },
  },
  computed: {},
  data() {
    return {};
  },
  methods: {
    changeMatch(match) {
      var mathtrans =
        match == 18
          ? 'CFI'
          : match == 19
          ? 'CFV'
          : match == 20
          ? 'SFI'
          : match == 21
          ? 'SFV'
          : match == 22
          ? 'FI'
          : match == 86
          ? 'FV'
          : match.replace('Matchday ', 'J');

      return mathtrans;
    },
    changeNameReferee(name) {
      if (name === 'Sin designar') {
        return name;
      }
      let nameRefereePrint = '';
      if (name != null) {
        let nameTrim = name.trim();
        let auxReferee = nameTrim.split(', ');
        let apellidoAuxReferee = auxReferee[0].split(' ');
        let nameAuxReferee = auxReferee[1].split(' ');
        let auxNameInitials = '';
        for (let index = 0; index < nameAuxReferee.length; index++) {
          auxNameInitials += nameAuxReferee[index].charAt(0) + '. ';
        }
        nameRefereePrint = auxNameInitials + '' + apellidoAuxReferee[0];
      }
      return nameRefereePrint;
    },
  },
  created() {},
};
</script>
<style lang="scss" scoped>
.color-gray {
  background-color: #f6f8fb !important;
}
.table-events-referee {
  width: 100%;
  height: 181px;
  border-radius: 6px;
  border: solid 1px #b4c9dd;
  background-color: #fff;
  display: inline-flex;
  justify-content: left;
  align-content: center;
  align-items: center;
  overflow: hidden;
  @media screen and (max-width: 830px) {
    display: inline-block;
    height: auto;
  }
  &__col-info {
    width: 22.2%;
    height: 181px;
    background: yellow;
    border-right: solid 1px #b4c9dd;
    @media screen and (max-width: 830px) {
      display: none;
    }
    &__row-referee-info {
      width: 100%;
      height: 123px;
      background-color: #f6f8fb;
      display: inline-block;
      justify-content: center;
      align-content: center;
      align-items: center;
      img {
        width: 48px;
        margin-top: 14px;
      }
      &__name {
        font-size: 16px;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        line-height: 20px;
        letter-spacing: normal;
        text-align: center;
        color: #132839;
        font-family: 'Avenir-Bold';
        text-overflow: ellipsis;
        overflow: hidden;
        width: 100%;
        height: 20px;
        white-space: nowrap;
      }
    }
    &__row-category {
      width: 100%;
      height: 29px;
      background-color: #ffffff;
      font-size: 13px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 29px;
      letter-spacing: normal;
      text-align: left;
      padding-left: 12%;
      color: #132839;
      font-family: 'Avenir-Demi';
    }
  }
  &__col {
    width: 26.2%;
    height: 181px;
    background: #f6f8fb;
    border-right: solid 1px #b4c9dd;
    @media screen and (max-width: 830px) {
      width: 100%;
      height: auto;
    }
    &__row-title {
      width: 100%;
      height: 46px;
      background: white;
      font-size: 13px;
      display: inline-flex;
      justify-content: center;
      align-content: center;
      align-items: center;
      font-weight: normal;
      font-family: 'Avenir-Demi';
      font-stretch: normal;
      font-style: normal;
      letter-spacing: normal;
      text-align: center;
      color: #132839;
    }
    &__row-cont-sub-title {
      width: 100%;
      height: 77px;
      display: inline-flex;
      justify-content: left;
      align-content: center;
      align-items: center;
      &__empty {
        display: none;
        @media screen and (max-width: 830px) {
          width: 24%;
          background-color: #f6f8fb;

          display: inline-flex;
          justify-content: center;
          align-content: center;
          align-items: center;
        }
      }
      &__match-title {
        width: 50%;
        display: inline-flex;
        justify-content: center;
        align-content: center;
        align-items: center;
        height: 77px;
        background-color: #52a0fc;
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.29;
        letter-spacing: normal;
        text-align: center;
        font-family: 'Avenir-Demi';
        color: #fff;
        @media screen and (max-width: 830px) {
          width: 38%;
        }
      }
      &__prom-title {
        width: 50%;
        height: 77px;
        background-color: #4286d8;
        font-size: 14px;
        display: inline-flex;
        justify-content: center;
        align-content: center;
        align-items: center;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        font-family: 'Avenir-Demi';
        line-height: 1.29;
        letter-spacing: normal;
        text-align: center;
        color: #fff;
        @media screen and (max-width: 830px) {
          width: 38%;
        }
      }
    }
    &__row-cont-values {
      width: 100%;
      height: 29px;
      background: white;
      display: inline-flex;
      justify-content: left;
      align-content: center;
      align-items: center;
      &__category {
        display: none;
        @media screen and (max-width: 830px) {
          width: 24%;
          height: 29px;
          display: inline-flex;
          justify-content: left;
          align-content: center;
          align-items: center;

          font-size: 13px;
          font-weight: normal;
          font-stretch: normal;
          font-style: normal;
          padding-left: 5%;
          line-height: 29px;
          letter-spacing: normal;
          text-align: left;
          color: #132839;
        }
      }
      &__match-val {
        width: 50%;
        height: 29px;
        font-size: 13px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 29px;
        letter-spacing: normal;
        text-align: center;
        font-family: 'Avenir-Demi';
        color: #132839;
        border-right: solid 1px #b4c9dd;
        @media screen and (max-width: 830px) {
          width: 38%;
        }
      }
      &__prom-val {
        width: 50%;
        height: 29px;
        font-size: 13px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 29px;
        letter-spacing: normal;
        text-align: center;
        color: #132839;
        font-family: 'Avenir-Demi';
        @media screen and (max-width: 830px) {
          width: 38%;
        }
      }
    }
  }
}
</style>
